import { render, staticRenderFns } from "./cancellationIndex.vue?vue&type=template&id=5bc84235"
import script from "./cancellationIndex.vue?vue&type=script&lang=js"
export * from "./cancellationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports